import { RULE_BASE_ID } from './columnConfig';

export const tableConfig = {
  selectable: true,
  pagination: false,
  index: RULE_BASE_ID,
};
